import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import SocialLogin from './components/SocialLogin';
import Icon from '../../components/AppIcon';
import { initializeAdmin } from '../../utils/seedAdmin';
import logo from '/assets/images/logo.png'; // Importa el logo

const LoginScreen = () => {
  // Initialize admin user on component mount
  useEffect(() => {
    const initAdmin = async () => {
      await initializeAdmin();
    };
    initAdmin();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Simplified Header */}
      <header className="bg-primary border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center h-16">
            <Link to="/book-catalog-browse-screen" className="flex items-center space-x-2">
              {/* Logo grande y centrado en vez del texto */}
              <img 
                src={logo} 
                alt="Logo Librería Lithay" 
                style={{ width: '140px', height: 'auto', display: 'block' }} 
              />
            </Link>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <div className="max-w-md mx-auto">
            {/* Login Form */}
            <LoginForm />

            {/* Social Login Options */}
            <div className="mt-8">
              <SocialLogin />
            </div>

            {/* Trust Signals */}
            <TrustSignals />
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="bg-muted border-t border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-center space-y-2">
            <p className="text-sm text-muted-foreground font-medium">
              © {new Date().getFullYear()} Librería Lithay. Todos los derechos reservados.
            </p>
            <p className="text-sm text-muted-foreground italic">
              Difundiendo la palabra de Dios a través de la literatura cristiana
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LoginScreen;
